export default __webpack_public_path__ + "static/media/biblioteca.a29c8932.png";